import { useEffect, useRef, useState } from 'react';

import { Nullable } from '@/types/common';

interface IntersectionObserverProps extends IntersectionObserverInit {
  target?: Nullable<HTMLElement>;
  freeze?: boolean;
}

const useIntersectionObserver = ({
  target,
  freeze = false,
  threshold = 0,
  root = null,
  rootMargin = '0%',
}: IntersectionObserverProps) => {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();
  const observer = useRef<Nullable<IntersectionObserver>>(null);

  const updateEntry = ([currentEntry]: IntersectionObserverEntry[]) => {
    setEntry(currentEntry);
  };

  const cleanObserver = () => {
    if (observer.current) {
      observer.current.disconnect();
    }
  };

  useEffect(() => {
    const hasIOSupport = 'IntersectionObserver' in window;

    if (!freeze && target && hasIOSupport) {
      const observerParams = { threshold, root, rootMargin };
      const observer = new IntersectionObserver(updateEntry, observerParams);
      observer.observe(target);
    }

    return () => {
      cleanObserver();
    };
  }, [target, root, rootMargin, threshold, freeze]);

  return entry;
};

export default useIntersectionObserver;
